/**
 * Safely toggles Electron kiosk mode when the preload exposes setKioskMode.
 * No-ops (returns false) in browser or when the API is unavailable.
 */
export const setKioskModeSafe = async (enabled: boolean): Promise<boolean> => {
  try {
    const setKioskMode = window?.electronAPI?.setKioskMode;
    if (typeof setKioskMode !== "function") {
      return false;
    }
    await setKioskMode(enabled);
    return true;
  } catch {
    return false;
  }
};
